import type { Reply } from "@circle-react/types/Live/QA/Reply";
import { reactQueryPatch } from "../helpers/backendRequestHelpers";
import { internalApi } from "../helpers/urlHelpers";

interface QAReplyParams {
  id?: string | number;
  questionId?: string | number;
  roomId?: string | number;
}

const pinQAReply = ({ roomId, questionId, id }: QAReplyParams) =>
  reactQueryPatch<Reply, QAReplyParams>(
    internalApi.liveStreams.pinQAReply({ roomId, questionId, id }),
  );

const unpinQAReply = ({ roomId, questionId, id }: QAReplyParams) =>
  reactQueryPatch<Reply, QAReplyParams>(
    internalApi.liveStreams.unpinQAReply({ roomId, questionId, id }),
  );

export const QARepliesApi = {
  pinQAReply,
  unpinQAReply,
};
